import React from "react";
import { ParticlesComponent } from "./components/Particles/Partices";
import LandingPage from "./pages/LandingPage/LandingPage";
import { Routes, Route, Navigate } from "react-router-dom";
import About from "./pages/About/About";
import { Navigation } from "./components/Navigation/Navigation";
import { SidebarSocials } from "./ui/atoms/molecules/SidebarSocials";
import Skills from "./pages/Skills/Skills";
import Projects from "./pages/Projects/Projects";
import Contact from "./pages/Contact/Contact";
function App() {
  return (
    <>
      <div className="App bg-gradient-to-br from-dark-800/80 to-dark-800/80">
        <Navigation />
        <SidebarSocials />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/about" element={<About />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/skills" element={<Skills />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </div>
      <ParticlesComponent />
    </>
  );
}

export default App;
